module.exports = __webpack_public_path__ + "img/stories_bg.dd2d8233.jpg";